//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { ApplicationContext } from './models/ApplicationContext';
import { Utilities } from './Utilities';

export class ApplicationsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getContext: (): string => {
            let clientRequestUrl = '/api/v3/applications/context';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves the execution context of the application.
     * @return OK
     */
    async getContext(): Promise<ApplicationContext> {
        const clientRequestUrl = this.baseUrl + this.routes.getContext();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<ApplicationContext>(_response, false, []);
    }
}
